<template>
  <div class="public_details">
    <div class="details_banner"></div>
    <div class="width_1280 df_flex df_wrap details_content">
      <back-navbar class="back-navbar">
        <span>返回</span>
      </back-navbar>
      <slot name="left" />
      <slot name="right" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PublicDetails',
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.public_details {
  position: relative;
  //padding-top: 54px; // 减去顶部导航栏高度
  // min-height: 1200px;
  &:has(.left) {
    // 包含左侧插槽的 返回按钮吸顶
    .back-navbar {
      position: sticky;
      top: 54px;
    }
  }
  .details_banner {
    width: 100%;
    height: 470px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: -1;

    // background-image: url('~@/assets/images/client/search-back/achievement.jpg'); // 示例图片，详情页面自己修改
    background-size: 100% auto;
    background-repeat: no-repeat;
  }
  .left {
    position: sticky;
    top: 190px;
    height: max-content;
  }
  .details_content {
    justify-content: center;
    // padding-top: 60px;
  }
}
</style>
